


























































































































































































import { HomePaths, SignalREvents } from '@/core/constants';
import scrollService from '@/core/scroll/scroll.service';
import { User } from '@/models/user/user.model';
import { BugTrackerModule } from '@/store/modules/bugtracker/bugtracker.store';
import { RealmsModule } from '@/store/modules/realms/realms.store';
import { UserModule } from '@/store/modules/user/user.store';
import { BugTrackerCategoryViewObject, BugTrackerIssueDetailsViewModel, BugTrackerIssueReactionRequest, BugTrackerPriority, BugTrackerStatus, ReactionType } from '@/types/apiServerContract';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import bugtrackerService from './bugtracker.service';
import BugTrackerAdminControls from './BugTrackerAdminControls.vue';
import TextEditor from '@/plugins/text-editor/TextEditor.vue';
import bus from '@/core/bus';
import Reactions from '@/components/frontpage/reactions/Reactions.vue';
import BugTrackerDetailsComment from './BugTrackerDetailsComment.vue';
import BugTrackerDetailsSubmitComment from './BugTrackerDetailsSubmitComment.vue';

@Component({
    components: { BugTrackerAdminControls, TextEditor, Reactions, BugTrackerDetailsComment, BugTrackerDetailsSubmitComment }
})
export default class BugTrackerDetailsPage extends Vue {
    @Prop({ required: true, type: Number })
    id!: number;

    @Prop({ required: true, type: Array })
    categories!: BugTrackerCategoryViewObject[];

    get details(): BugTrackerIssueDetailsViewModel | null {
	    return BugTrackerModule.details;
    }

    get issue() {
        return this.details?.issue;
    }

	editMode: boolean = false;

	toggleEdit(state: boolean) {
	    this.editMode = state;
	}

	showComments: boolean = false;
	expanded: boolean = false;

	toggleComments() {
	    this.showComments = !this.showComments;
	}

	setFixedHeight(el: HTMLElement) {
	    el.style.height = el.scrollHeight + 'px';
	    el.style.overflow = 'hidden';
	}

	setAutoHeight(el: HTMLElement) {
	    el.style.height = 'auto';
	    el.style.overflow = 'visible';
	}

    loading: boolean = false;
    loaded: boolean = false;

    get isLoggedIn() {
        return UserModule.IsLoggedIn;
    }

    get user(): User | null {
	    return UserModule.user;
    }

    get isAdmin() {
	    return this.user?.IsAdmin ?? false;
    }

    get isIssueOwner() {
	    return this.user != null && (this.isAdmin || this.issue?.createdBy === this.user?.id);
    }

    get issueOwner() {
        return this.issue?.createdByUser;
    }

    get assignee() {
        return this.details?.assignee;
    }

    getCategory(category: number) {
        return this.categories.find(x => x.id === category)?.name;
    }

    getPriority(priority: BugTrackerPriority) {
        return bugtrackerService.getPriority(priority);
    }

    getPriorityColor(priority: BugTrackerPriority) {
        return bugtrackerService.getPriorityColor(priority);
    }

    getStatus(status: BugTrackerStatus) {
        return bugtrackerService.getStatus(status);
    }

    getStatusColor(status: BugTrackerStatus) {
        return bugtrackerService.getStatusColor(status);
    }

    getRealmName(realmId: number) {
        return this.realms.find(x => x.id === realmId)?.name ?? 'All realms';
    }

    get realms() {
	    return RealmsModule.realms;
    }

    scrollToTop() {
        const element = document.getElementById('main-content');
        if (element) {
            scrollService.scrollToElement(element, -200);
        }
    }

    async getIssueDetails() {
        if (isNaN(this.id)) {
            this.$router.push(HomePaths.BugTracker);
            return;
        }

        try {
            await BugTrackerModule.getIssueDetails(this.id);
        } catch (e) {
            this.$router.push(HomePaths.BugTracker);
        } finally {
            this.loaded = true;
        }
    }

    validateRemovedIssue(data: { id: number, callback: () => void }) {
        if (this.issue?.id === data.id) {
            this.$bvToast.toast('This issue has been removed. Therefor you have being redirected.', {
	            variant: 'warning',
                title: 'Issue Deleted',
                autoHideDelay: 5000
            });

            this.$router.push(HomePaths.BugTrackerSearch);

            data.callback();
        }
    }

    async reacted(data: { type: ReactionType; active: boolean }) {
	    const request: BugTrackerIssueReactionRequest = {
	        type: data.type,
	        issueId: this.issue!.id,
	        active: data.active
	    };

	    await BugTrackerModule.issueReaction(request);
    }

    created() {
        this.getIssueDetails();
        bus.on(SignalREvents.BugTrackerIssueRemoved, this.validateRemovedIssue);
    }

    destroyed() {
        bus.off(SignalREvents.BugTrackerIssueRemoved, this.validateRemovedIssue);
        BugTrackerModule.clearDetails();
    }

    mounted() {
        this.scrollToTop();
    }

    @Watch('id')
    onIdChange() {
        this.getIssueDetails();
    }
}
